import { Component, EventEmitter, OnInit, Output, inject } from "@angular/core";
import { Platform } from "@ionic/angular";
import { Utils } from "@shared-utils/Utils";
import { AnimationOptions, LottieComponent } from "ngx-lottie";
import { AnimationItem } from "ngx-lottie/lib/symbols";

@Component({
  selector: "animated-splash",
  templateUrl: "./animated-splash.html",
  standalone: true,
  imports: [LottieComponent],
})
export class AnimatedSplash implements OnInit {
  @Output() animationCompleted = new EventEmitter<void>();
  private utils = inject(Utils);
  private platform = inject(Platform);

  options: AnimationOptions = {
    loop: false,
    autoplay: false,
  };

  styles: Partial<CSSStyleDeclaration> = {
    backgroundColor: "black",
    position: "relative",
    zIndex: "1000001",
  };

  async ngOnInit() {
    await this.platform.ready();
    const isCasino = await this.utils.isCasinoApp();

    this.options = {
      ...this.options,
      path: isCasino ? "assets/global/lottie/casino-splash.json" : "assets/global/lottie/splash.json",
    };
  }

  animationCreated(animation: AnimationItem) {
    animation.play();
  }

  complete() {
    this.animationCompleted.emit();
  }
}
